import classNames from 'classnames';
import { FC } from 'react';

import { getIconPayments } from '../../../icons';

import styles from './PaymentSystemSelectForm.module.scss';
import { SelectForm, SelectFormOption, SelectFormProps } from './SelectForm';

const paymentSystemOptions: SelectFormOption<string>[] = [
  {
    name: 'PayPal',
    fee: 3,
  },
  {
    name: 'Google Pay',
    fee: 5,
  },
  {
    name: 'American Express',
    fee: 2.8,
  },
  {
    name: 'Mastercard',
    fee: 2.6,
  },
  {
    name: 'Apple Pay',
    fee: 2.6,
  },
  {
    name: 'JCB',
    fee: 1,
  },
  {
    name: 'WeChat',
    fee: 3,
  },
  {
    name: 'Giropay',
    fee: 8,
  },
  {
    name: 'Neteller',
    fee: 1,
  },
  {
    name: 'Alipay',
    fee: 6,
  },
  {
    name: 'Bitcoin',
    fee: 0.6,
  },
  {
    name: 'Skrill',
    fee: 2.2,
  },
].map((payment) => ({
  name: (
    <div className={styles.paymentCard}>
      <div className={styles.paymentCardName}>
        {getIconPayments(payment.name)}
        <span className={styles.paymentName}>{payment.name}</span>
      </div>
      <span>{payment.fee}%</span>
    </div>
  ),
  value: payment.name,
}));

type PaymentSystemSelectFormProps = Omit<SelectFormProps<string>, 'options'>;

export const PaymentSystemSelectForm: FC<PaymentSystemSelectFormProps> = (props) => {
  const { className, ...selectFormProps } = props;

  return (
    <SelectForm
      {...selectFormProps}
      className={classNames(className, styles.selectForm)}
      options={paymentSystemOptions}
    />
  );
};
